import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=5c55de64&scoped=true&"
import script from "./ProjectView.vue?vue&type=script&lang=js&"
export * from "./ProjectView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=5c55de64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55de64",
  null
  
)

export default component.exports